// extracted by mini-css-extract-plugin
module.exports = {"button":"close-button_button__2nobi","icon--white":"close-button_icon--white__1o3y6","icon--black":"close-button_icon--black__3UwXN"};